import React from 'react';
import { Award, Globe, GraduationCap, BookOpen, User } from 'lucide-react';
import { Card } from './ui/card';

const TeamSection = () => {
  const team = [
    {
      id: 'kalah',
      name: 'Kalah K. Singam',
      role: 'Founder & Lead Educator',
      credentials: 'Early Childhood Educator | Montessori Trainer | Teacher Trainer',
      photo: 'https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/hgf3789w_ChatGPT%20Image%20Jun%2019%2C%202026%2C%2009_02_44%20PM.png',
      bio: 'With over 20 years of experience in teaching, early literacy, phonics instruction, curriculum development, and teacher mentoring, Kalah is passionate about helping children build strong foundations in reading, writing, and learning confidence.',
      icons: [
        { icon: Award, label: '20+ Years Experience' },
        { icon: GraduationCap, label: 'Montessori Trainer' }
      ]
    },
    {
      id: 'vivania',
      name: 'Vivania Shakti Ram',
      role: 'Early Childhood Educator',
      credentials: 'TESL Diploma | HEI Schools Diploma',
      photo: 'https://customer-assets.emergentagent.com/job_early-literacy-hub-3/artifacts/1xczfia5_IMG-20260621-WA0008.jpg',
      bio: 'Vivania teaches young children through engaging, child-centred lessons. She holds a Diploma in TESL and a HEI Schools Diploma, and has experience teaching early French and supporting children across European time zones through online learning.',
      icons: [
        { icon: Globe, label: 'International Experience' },
        { icon: BookOpen, label: 'TESL & HEI Schools' }
      ]
    }
  ];

  return (
    <section id="team" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-blue-50 text-[#3B4BA0] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Meet Our Team
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            The Educators Behind Read Right Academy
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Dedicated educators bringing warmth, structure, and proven methodology 
            to every child's learning journey.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {team.map((member) => (
            <Card
              key={member.id}
              data-testid={`team-member-${member.id}`}
              className="overflow-hidden border-2 border-gray-100 hover:border-[#3B4BA0] hover:shadow-2xl transition-all duration-300 bg-white"
            >
              <div className="flex flex-col sm:flex-row">
                {/* Photo */}
                <div className="sm:w-2/5 relative aspect-square sm:aspect-auto bg-gradient-to-br from-blue-100 via-teal-50 to-blue-50 flex-shrink-0">
                  {member.photo ? (
                    <img
                      src={member.photo}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center p-6 text-center">
                      <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg mb-3">
                        <User className="h-12 w-12 text-[#3B4BA0]" />
                      </div>
                      <p className="text-xs text-gray-500 italic">Photo coming soon</p>
                    </div>
                  )}
                </div>

                {/* Info */}
                <div className="sm:w-3/5 p-6 sm:p-7 flex flex-col">
                  <h3 className="text-2xl font-bold text-gray-900 mb-1">
                    {member.name}
                  </h3>
                  <p className="text-[#3B4BA0] font-semibold mb-3">
                    {member.role}
                  </p>
                  <p className="text-xs text-gray-500 mb-4 leading-relaxed">
                    {member.credentials}
                  </p>
                  <p className="text-sm text-gray-700 leading-relaxed mb-5 flex-grow">
                    {member.bio}
                  </p>

                  {/* Highlights */}
                  <div className="space-y-2 pt-4 border-t border-gray-100">
                    {member.icons.map((item, idx) => {
                      const IconComponent = item.icon;
                      return (
                        <div key={idx} className="flex items-center gap-2 text-xs text-gray-600">
                          <IconComponent className="h-4 w-4 text-[#3B4BA0] flex-shrink-0" />
                          <span>{item.label}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
